/**
 * Utilidades para manejo de tipos de usuario
 */

/**
 * Obtiene el mensaje de saludo personalizado según el tipo de usuario
 * @param {Object} user - Objeto usuario con role_description y name
 * @returns {string} - Mensaje de saludo personalizado
 */
export const getWelcomeMessage = (user) => {
  if (!user) return '¡Bienvenido!';
  
  const { name, role_description } = user;
  const userName = name || 'Usuario';
  const userRole = role_description || '';
  
  const greetings = {
    'Administrador': '¡Bienvenido de vuelta, Administrador',
    'Auditor': '¡Hola, Auditor',
    'Usuario': '¡Bienvenido'
  };
  
  const greeting = greetings[role_description] || '¡Bienvenido';
  
  return userRole 
    ? `${greeting} ${userName}! (${userRole})`
    : `¡Bienvenido ${userName}!`;
};

/**
 * Obtiene el color de tema basado en el tipo de usuario
 * @param {Object} user - Objeto usuario con role y role_color
 * @returns {string} - Color de tema
 */
export const getUserThemeColor = (user) => {
  if (!user || !user.role_color) return 'primary';
  
  const colorMap = {
    'danger': '#dc3545',
    'warning': '#ffc107', 
    'primary': '#007bff',
    'secondary': '#6c757d'
  };
  
  return colorMap[user.role_color] || '#007bff';
};

/**
 * Verifica si el usuario tiene permisos de administrador
 * @param {Object} user - Objeto usuario
 * @returns {boolean} - True si es administrador
 */
export const isAdmin = (user) => {
  return user && (user.role === 'admin' || user.tip_user === 1 || user.tip_user === '1');
};

/**
 * Verifica si el usuario tiene permisos de auditor
 * @param {Object} user - Objeto usuario
 * @returns {boolean} - True si es auditor
 */
export const isAuditor = (user) => {
  return user && (user.role === 'auditor' || user.tip_user === 3 || user.tip_user === '3');
};

/**
 * Verifica si el usuario puede acceder a una funcionalidad específica
 * @param {Object} user - Objeto usuario
 * @param {string|Array} requiredRoles - Rol(es) requerido(s)
 * @returns {boolean} - True si tiene acceso
 */
export const hasAccess = (user, requiredRoles) => {
  if (!user) return false;
  
  const roles = Array.isArray(requiredRoles) ? requiredRoles : [requiredRoles];
  const userRole = user.role || '';
  
  return roles.includes(userRole) || isAdmin(user);
};

/**
 * Obtiene el icono apropiado según el tipo de usuario
 * @param {Object} user - Objeto usuario
 * @returns {string} - Nombre del icono
 */
export const getUserIcon = (user) => {
  if (!user) return 'person';
  
  const iconMap = {
    'admin': 'admin_panel_settings',
    'auditor': 'security',
    'usuario': 'person'
  };
  
  return iconMap[user.role] || 'person';
};